<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="infodata.banner" /></div>
        </div>

        <div class="infopage">

            <div class="infonews" v-if="$common.basic.isarrayexist(infodatanews1list)">
                <div class="infosub realwrap">
                    <div class="infosubmewswrap">
                        <div class="subtitle"><div class="word">{{$common.langinfo(infodatanews1.title,infodatanews1.title_en)}} </div></div>
                        <dl class="infosubnews" v-for="(item,index) in infodatanews1list" v-if="index<2" :key="item.id">
                            <dd class="a"><i class="iconfont icon-round"></i><fflink :info="item"></fflink></dd>
                            <dd class="b">{{$common.dicword('publishdate',true)+$common.basic.dateformat(item.datepublish)}}</dd>
                            <dd class="c"><span v-html="$common.basic.strgetlen($common.langinfo(item.content,item.content_en),100)"></span></dd>
                        </dl>
                        <div class="infosubnewsall"><a href="#" v-if="!isallnotice && infodatanews1list.length>2" class="infomore" @click="isallnotice=true">{{$common.dicword('allnotice')}}</a></div>
                    </div>
                    <div class="infosubnewsimg">
                        <img :src="infodatanews1.cover" class="infosub2img" />
                    </div>
                </div>

                <div class="infosubnewsmorewrap realwrap" v-if="isallnotice && infodatanews1list.length>2">
                    <div class="infosubnewsmore ">
                        <div class="infosubmewswrap" v-for="(item,index) in infodatanews1list" :key="item.id" v-if="index>=2">
                            <dl class="infosubnews">
                                <dd class="a"><i class="iconfont icon-round"></i><fflink :info="item"></fflink></dd>
                                <dd class="b">{{$common.dicword('publishdate',true)+$common.basic.dateformat(item.datepublish)}}</dd>
                                <dd class="c"><span v-html="$common.basic.strgetlen($common.langinfo(item.content,item.content_en),100)"></span></dd>
                            </dl>

                        </div>
                    </div>
                </div>

            </div>

            <div class="infonews" v-if="$common.basic.isarrayexist(infodatanews2list)">
                <div class="infosub realwrap">
                    <div class="infosubmewswrap">
                        <div class="subtitle"><div class="word">{{$common.langinfo(infodatanews2.title,infodatanews2.title_en)}} </div> <router-link to="/news/list" class="infomore">{{$common.dicword('more')}}</router-link></div>
                        <dl class="infosubnews" v-for="item in infodatanews2list" :key="item.id">
                            <dd class="a"><i class="iconfont icon-round"></i><fflink :info="item"></fflink></dd>
                            <dd class="b">{{$common.dicword('publishdate',true)+$common.basic.dateformat(item.datepublish)}}</dd>
                            <dd class="c"><span v-html="$common.basic.strgetlen($common.langinfo(item.content,item.content_en),100)"></span></dd>
                            <dd class="d"><fflink linktype="btn" :info="item"></fflink></dd>
                        </dl>
                    </div>
                    <div class="infosubnewsimg">
                        <img :src="infodatanews2.cover" class="infosub2img" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'news',
        data() {
            return {
                infodata: {},
                infodatanews1: {},
                infodatanews1list: [],
                infodatanews2: {},
                infodatanews2list: {},
                isallnotice: false
            };
        },
        mounted() {


            this.$common.fetch({ 'act': 'tc_news_home' }, res => {
                this.$common.each(res.infodatanews1list, (item) => {
                    item.x_url = res.infodatanews1.url + '/' + item.id;
                    item.x_len = 30;
                    item.x_btn = '[' + this.$common.dicword('viewdetail') + ']';
                });

                this.$common.each(res.infodatanews2list, (item) => {
                    item.x_url = res.infodatanews2.url + '/' + item.id;
                    item.x_len = 30;
                    item.x_btn = '[' + this.$common.dicword('viewdetail') + ']';
                });

                this.infodata = res.infodata;
                this.infodatanews1 = res.infodatanews1;
                this.infodatanews1list = res.infodatanews1list;
                this.infodatanews2 = res.infodatanews2;
                this.infodatanews2list = res.infodatanews2list;
            });

        }
    }
</script>
